import "../categories/categories.css";
import { NavDropdown, Dropdown, Spinner, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import apiEndPoint from "../../utils/apiEndPoint";
import { Fragment, useEffect } from "react";
import Templateview from "../templateview";
import { Select } from "antd";
import React, { useState } from 'react';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import { loadFromLocalStorage, saveToLocalStorage } from "../../utils/LocalStorageUtils";
import { apiCall, failedMessage, successMessage } from "../../utils/httpClient";
import Footer from "../../layout/footer";
import Header from "../../layout/header";
import { isEmpty } from "utils/utils";
import { Placeholder } from "reactstrap";

function Categories() {
  const urlParams = new URLSearchParams(window.location.search);
  const isFavourite = urlParams.get('is_favourite');
  const categoryId = urlParams.get('category_id');
  const [templatesList, setTemplatesList] = useState([]);
  const [base_url, setbaseurl] = useState([]);
  const [themeBaseUrl, setThemeBaseurl] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [selectPage, setSelectPage] = useState("");
  const [templateViewPage, setTemplateViewPage] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const authData = loadFromLocalStorage("AUTH_DATA");
  useEffect(() => {
    getCategoryList();
  }, []);
  useEffect(() => {
    getTemplatesList();
  }, [currentPage, isFavourite, categoryId]);
  const getCategoryList = async () => {
    const { data } = await apiCall("post", apiEndPoint.GETCATEGORY);
    if (data.status === 200) {
      setCategories(data.data);
    } else {
      failedMessage(data.message);
    }
  };
  const getTemplatesList = async (item) => {
    let params = { limit: 6, offset: currentPage === 0 ? 0 : currentPage - 1, is_favourite: Boolean(isFavourite) };
    if (item != undefined) {
      params["category_id"] = item;
    } else if (!isEmpty(categoryId)) {
      params["category_id"] = categoryId;
    }
    const { data } = await apiCall("post", apiEndPoint.GETTEMPLATE, params);
    if (data.status === 200) {
      setTemplatesList(data.data);
      setTotalPages(Math.ceil(data?.total_data / 6));
      setbaseurl(data.base_url);
      setThemeBaseurl(data.theme_base_url);
    } else {
      setTemplatesList([]);
      failedMessage(data.message);
    }
    setLoading(false)
  };
  const handleSavedTemplate = async (item) => {
    const { data } = await apiCall("post", apiEndPoint.FAVOURITETHEMESTATUSUPDATE, {
      is_favourite: true,
      template_id: item._id,
    });
    if (data.status === 200) {
      successMessage(data.message)
      getTemplatesList();
    }
  };

  const navigate = useNavigate();
  return (
    <Fragment>
      {selectPage == "" ? (
        <>
          <div className="cte-title">
            <h3>Pick the Website Template You Love</h3>
          </div>
          <div className="ctegory-header txt-centr">
            <Navbar expand="xl" className="bg-body-tertiary cst-nav">
              <Container fluid>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                  <Nav className="me-auto" navbarScroll>
                    <NavDropdown
                      className="pr-2 py-2 align-text-top"
                      title="Business & Services"
                      id="basic-nav-dropdown"
                    >
                      <div className="container-fluid">
                        <div className="row w-100">
                          <div className="col-lg-12 col-12 align-self-center">
                            <Dropdown.Header className="w-100"
                              onClick={() => {
                                navigate("/categories");
                              }}
                            >
                              <h6>Select Category :</h6>
                              <Select
                                className="wid-select-two"
                                showSearch
                                optionFilterProp="children"
                                onChange={(e) => getTemplatesList(e)}
                              >
                                {categories &&
                                  categories.map((item, index) => (
                                    <Select.Option key={item._id} value={item._id}>
                                      {item.category_name}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <br />
                            </Dropdown.Item>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                    <NavDropdown
                      className="pr-2 py-2 align-text-top"
                      title="Store"
                      id="basic-nav-dropdown"
                    >
                      <div className="container eventsNav pt-0 mt-0">
                        <div className="row">
                          <div className="col-lg-12 text-left">
                            <Dropdown.Header>
                              Catering
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/categories");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Corporate
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/categories");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Private
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Header>
                              Classes
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Barista 101
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  History of Coffee
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Intro to Cafe Snobbery
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Divider className="d-md-none" />
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                    <NavDropdown
                      className="pr-2 py-2 align-text-top"
                      title="Creative"
                      id="basic-nav-dropdown"
                    >
                      <div className="container eventsNav pt-0 mt-0">
                        <div className="row">
                          <div className="col-lg-12 text-left">
                            <Dropdown.Header>
                              Catering
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Corporate
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Private
                                </a>
                              </span>
                            </Dropdown.Item>

                            <Dropdown.Divider />
                            <Dropdown.Header>
                              Classes
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Barista 101
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  History of Coffee
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Intro to Cafe Snobbery
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Divider className="d-md-none" />
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                    <NavDropdown
                      className="pr-2 py-2 align-text-top"
                      title="Community"
                      id="basic-nav-dropdown"
                    >
                      <div className="container eventsNav pt-0 mt-0">
                        <div className="row">
                          <div className="col-lg-12 text-left">
                            <Dropdown.Header>
                              Catering
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Corporate
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Private
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Header>
                              Classes
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Barista 101
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  History of Coffee
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Intro to Cafe Snobbery
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Divider className="d-md-none" />
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                    <NavDropdown
                      className="pr-2 py-2 align-text-top"
                      title="Blog"
                      id="basic-nav-dropdown"
                    >
                      <div className="container eventsNav pt-0 mt-0">
                        <div className="row">
                          <div className="col-lg-12 text-left">
                            <Dropdown.Header>
                              Catering
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Corporate
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Private
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Header>
                              Classes
                            </Dropdown.Header>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Barista 101
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  History of Coffee
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <span
                                onClick={() => {
                                  navigate("/about");
                                }}
                              >
                                <a className="nav-link" role="button">
                                  Intro to Cafe Snobbery
                                </a>
                              </span>
                            </Dropdown.Item>
                            <Dropdown.Divider className="d-md-none" />
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                  </Nav>

                  <Select
                    className="wid-select"
                    showSearch
                    optionFilterProp="children"
                    onChange={(e) => getTemplatesList(e)}
                  >
                    {/* <Select.Option onClick={() => getTemplatesList()}>
                      All
                    </Select.Option> */}
                    {categories &&
                      categories.map((item, index) => (
                        <Select.Option key={item._id} value={item._id}>
                          {item.category_name}
                        </Select.Option>
                      ))}
                  </Select>
                  <Form className="d-flex align-items-center jst-tt">

                    <Nav.Link
                      onClick={() => {
                        navigate("/categories");
                      }}
                    >
                      All Templates
                    </Nav.Link>{" "}
                    |
                    <Nav.Link
                      onClick={() => {
                        navigate("/categories");
                      }}
                    >
                      Blank Templates
                    </Nav.Link>{" "}
                    |
                    <Nav.Link
                      onClick={() => {
                        navigate("/categories");
                      }}
                    >
                      Collections
                    </Nav.Link>
                  </Form>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </div>
          <section className="categories-card-sec">
            <div className="container-fluid">

              <hr />
              {isLoading ?
                <>
                  <center style={{ paddingTop: '15%' }}>
                    <Spinner animation="border" role="status" />
                  </center>
                  {/* {(<div className="catgcard-container">
                    <div className="row">
                      <Fragment>
                        {[1, 2, 3].map((item, index) => (
                          <div className="col-lg-4 col-md-6" key={index}>
                            <div className="mb-3">
                              <div className="card">
                                <Placeholder style={{height:150}} className="w-100 hjhjh" />
                                <div style={{
                                  display: 'flex',
                                  padding: '0.3rem',
                                  alignItems: 'center'
                                }}>
                                  <span>
                                    <Placeholder style={{ color: '#000000', textAlign: 'justify' }} as='h6' animation="glow">
                                      <Placeholder xs={12} bg="primary" />
                                    </Placeholder>
                                    <Placeholder as='small' animation="glow">
                                      <Placeholder xs={12} bg="primary" />
                                    </Placeholder>
                                  </span>

                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Fragment>
                    </div>
                  </div>)} */}
                </>
                :
                (<div className="catgcard-container">
                  <div className="row">
                    {templatesList.length > 0 ?
                      <Fragment>
                        {templatesList.map((item, index) => (
                          <div className="col-lg-4 col-md-6" key={index}>
                            <div className="mb-3">
                              <div className="card">
                                <img
                                  className="w-100 hjhjh"
                                  style={{
                                    backgroundImage: `url(${base_url +
                                      item.thumbnail})`,
                                  }}
                                />
                                <div style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  padding: '0.3rem',
                                  alignItems: 'center'
                                }}>
                                  <span>
                                    <h6 style={{ color: '#000000', textAlign: 'justify' }}>{item.title}</h6>
                                    <small style={{ color: '#000000', textAlign: 'justify' }}>{item.category_name}</small>
                                  </span>
                                  {authData?.token && (
                                    <a
                                      onClick={() => handleSavedTemplate(item)}>
                                      <Image
                                        style={{ width: 20 }}
                                        src={!isEmpty(item?.is_favourite) ? '/assets/images/icon/saved.png' : '/assets/images/icon/save.png'}
                                      />
                                    </a>
                                  )}
                                </div>
                                <div className="content">
                                  <div className="crds-btn">
                                    <Button
                                      variant="outline-primary"
                                      onClick={() => {
                                        saveToLocalStorage('selectTemplate', item);
                                        saveToLocalStorage("selectOrderDetail", null);
                                        navigate("/templateform");
                                      }}
                                    >
                                      Edit
                                    </Button>{" "}
                                    <Button
                                      variant="outline-primary"
                                      onClick={() => {
                                        // navigate("/templateview");
                                        saveToLocalStorage('selectTemplate', item)
                                        saveToLocalStorage("selectOrderDetail", null);
                                        setSelectPage("TemplateView");
                                        setTemplateViewPage(item);
                                      }}
                                    >
                                      View
                                    </Button>
                                    {""}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div >
                          <div className="mt-4 box_pagination">
                            <ResponsivePagination
                              current={currentPage}
                              total={totalPages}
                              onPageChange={setCurrentPage}
                            />
                          </div>
                        </div>
                      </Fragment>
                      : <center><h6>Templates not available</h6></center>}
                  </div>
                </div>)}
            </div>
          </section>
        </>

      ) : (
        <Templateview
          setTemplateViewPage={setTemplateViewPage}
          setSelectPage={setSelectPage}
          templateViewPage={templateViewPage}
          selectPage={selectPage}
          base_url={themeBaseUrl}
        />

      )}
    </Fragment>
  );
}

export default Categories;